import React from 'react';
import { PaystackPaymentButtons } from '../components/Payment/PaystackPaymentButtons';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PaymentPage() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  if (!user) {
    navigate('/login');
    return null;
  }
  return <div className="min-h-screen bg-black" data-id="element-9536">
      {/* Back Button */}
      <div className="p-6" data-id="element-9537">
        <button onClick={() => navigate('/dashboard')} className="flex items-center text-pink-400 hover:text-pink-300 transition-colors font-bold" data-id="element-9538">
          <ArrowLeft size={20} className="mr-2" data-id="element-9539" />
          Back to Dashboard
        </button>
      </div>

      {/* Payment Buttons */}
      <PaystackPaymentButtons data-id="element-9540" />
    </div>;
}